import * as R from 'remeda';
import { DedicatedEngineSchemaValidationResult } from '@rossum/api-client/dedicatedEngineSchema';

export const isErrorAtIndex = (
  errors: DedicatedEngineSchemaValidationResult,
  index: number
) => {
  return !!errors?.content?.fields?.[index];
};

export const anyErrors = (errors: DedicatedEngineSchemaValidationResult) =>
  !R.isEmpty(errors);
